import { flatten, get, has } from 'lodash';

const PRODUCT_EXPANDS = 'expand[]=options&expand[]=variants';

const MAX_FETCH_SIZE = 30;

export default {
    data() {
        return {
            isLoadingProducts: false,
            productDetails: []
        };
    },
    computed: {
        productStore: {
            get() {
                return this.$root.v2.productStore;
            },
            set(productStore) {
                this.$root.v2.productStore = productStore;
            }
        },
        productsUrl() {
            return `/api/v1/products?${PRODUCT_EXPANDS}`;
        }
    },
    methods: {
        readStore(productId) {
            return this.productStore[productId];
        },
        writeStore(product) {
            const products = flatten([product]);
            products.forEach((item) => {
                this.productStore[item.id] = item;
            });
        },
        existsStore(productId) {
            return has(this.productStore, productId);
        },
        buildProductsResponse(url) {
            this.isLoadingProducts = true;
            return this.$http
                .get(url)
                .then((res) => {
                    this.writeStore(res.data);
                    return res.data;
                })
                .catch(this.handleHttpError)
                .finally(() => (this.isLoadingProducts = false));
        },
        getProductsFromCache(productId) {
            const productIds = flatten([productId]);
            return productIds.map((id) => this.readStore(id));
        },
        getProducts(productId) {
            const productIds = flatten([productId]);

            if (!productIds.length) {
                return Promise.resolve([]);
            }

            const fetchProductIds = productIds.filter((id) => !this.existsStore(id));
            if (fetchProductIds.length > 0) {
                // If there are too many products to fetch at once, break into chunks, and merge result
                if (fetchProductIds.length > MAX_FETCH_SIZE) {
                    const productRequests = fetchProductIds
                        .map((item, i) =>
                            i % MAX_FETCH_SIZE === 0
                                ? this.getProducts(fetchProductIds.slice(i, i + MAX_FETCH_SIZE))
                                : null
                        )
                        .filter((item) => item);

                    return Promise.all(productRequests).then(() => this.getProductsFromCache(productIds));
                }

                const encodedIds = fetchProductIds.map((id) => `product_ids[]=${id}`);

                return this.buildProductsResponse(this.productsUrl + '&' + encodedIds.join('&')).then((res) => {
                    return this.getProductsFromCache(productIds);
                });
            } else {
                return Promise.resolve(this.getProductsFromCache(productIds));
            }
        },
        getProductsFromCheckoutUrl(briefId, url) {
            const route = `/api/v1/activation-briefs/${briefId}/checkout-products?${PRODUCT_EXPANDS}&url=${url}`;
            return this.buildProductsResponse(route);
        },
        getProductsFromStoreProductUrl(briefId, url) {
            const route = `/api/v1/activation-briefs/${briefId}/product-handle?${PRODUCT_EXPANDS}&url=${url}`;
            return this.buildProductsResponse(route);
        },
        getOrderProductDetails(brief) {
            if (get(brief, 'orders.length', 0) > 0) {
                return this.getProducts(this.brief.orders[0].items.map((item) => item.product_id)).then(
                    (res) => (this.productDetails = res)
                );
            }
        }
    }
};
